// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import * as React from "react";
import { FC, useContext } from "react";
import { css } from "styled-components";

export interface EByEmserBadgePresentationProps extends ExpandStyles<EByEmserBadgeStyles> {}

export interface EByEmserBadgeProps extends EByEmserBadgePresentationProps {
    labelOverride?: string;
}

export interface EByEmserBadgeStyles {
    wrapper?: InjectableCss;
    label?: TypographyPresentationProps;
}

export const eByEmserBadgeStyles: EByEmserBadgeStyles = {
    wrapper: {
        css: css`
            position: absolute;
            top: ${pxToRem(22)};
            left: ${pxToRem(12)};
            display: inline-flex;
            padding: ${pxToRem(3, 10)};
            background-color: ${getColor("eByEmserBadge.backgroundColor")};
        `,
    },
    label: {
        forwardAs: "span",
        css: css`
            font-size: ${pxToRem(11)};
            text-transform: uppercase;
            vertical-align: middle;
            font-weight: ${x => x.theme.design.typography.weight.semibold};
            color: ${getColor("eByEmserBadge.labelColor")};
        `,
    },
};

const EByEmserBadge: FC<EByEmserBadgeProps> = ({ labelOverride, extendedStyles, overridedStyles, ...otherProps }) => {
    const styles = useExpandProps(eByEmserBadgeStyles, extendedStyles, overridedStyles);
    const { product } = useContext(ProductContext);

    const redirectUrl = product?.properties?.redirectEbyEmserUrl;
    const showBadge = !!redirectUrl;

    if (!showBadge) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper} {...otherProps}>
            <Typography {...styles.label}>{labelOverride ?? translate("E™ BY EMSER TILE")}</Typography>
        </StyledWrapper>
    );
};

export default EByEmserBadge;
